<template>
  <b-row class="feedback-promo">
    <b-col sm="12">
      <b-card class="feedback-promo__card">
        <h3 class="feedback-promo__title">Thank you for your feedback.</h3>

        <p class="feedback-promo__subtitle">Would you like to download the CPDme App?</p>
        <p class="feedback-promo__copy">Make your recording CPD Simple with a Free 14 Day Trial</p>
        <p class="feedback-promo__copy">Create a free account to manage your own CPD</p>

        <div class="feedback-promo__store-links">
          <a
            class="d-inline-block"
            target="_blank"
            rel="noopener noreferrer"
            href="https://play.google.com/store/apps/details?id=eu.cpdcloud.cpdmeportfolio&hl=en_GB"
          >
            <img
              alt="Google Play"
              width="200"
              src="../../assets/auth/btn-google-play.png"
            >
          </a>

          <a
            class="d-inline-block"
            target="_blank"
            rel="noopener noreferrer"
            href="https://apps.apple.com/gb/app/cpd-portfolio/id668426981"
          >
            <img
              alt="App Store"
              width="200"
              src="../../assets/auth/btn-app-store.png"
            >
          </a>
        </div>

        <div class="mt-3">
          <a
            class="feedback-promo__join-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cpdme.com/"
          >
            Learn more about CPDme
          </a>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "FeedbackPromotion",
};
</script>

<style scoped>
.feedback-promo {
  max-width: 800px;
  margin: auto;
  padding: 20px 10px;
}

.feedback-promo__card {
  text-align: center;
}

.feedback-promo__title {
  margin-bottom: 12px;
  color: #2c3e50;
}

.feedback-promo__subtitle {
  margin-bottom: 8px;
  font-weight: 600;
}

.feedback-promo__copy {
  margin-bottom: 8px;
  color: #4f5d6b;
}

.feedback-promo__store-links {
  margin-top: 16px;
  display: flex;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
}

.feedback-promo__join-link {
  text-decoration: underline;
}
</style>
